import React, { useState, createContext, useEffect } from 'react';

export const FilterContext = createContext({
  filter: {
    first: 0,
    rows: 20,
    sortField: null,
    sortOrder: null,
    filters: {
        'id': { value: null, matchMode: 'contains' },
        'produtoNome': { value: '', matchMode: 'contains' },
        'produtoEmbalagem': { value: '', matchMode: 'contains' },
        'valor': { value: '', matchMode: 'contains' },
        'data': { value: '', matchMode: 'equals' },
        'produtoGrupoId': { value: null, matchMode: 'equals' },
        'produtoGrupoNome': { value: null, matchMode: 'equals' },
        'pessoaNome': { value: null, matchMode: 'equals' },
        'produtoTipo': { value: null, matchMode: 'equals' }
    }},
  setFilter: () => {}
});

const FilterProvider = ({ children }) => {
  const [filter, setFilter] = useState(localStorage.getItem('filter'));

  useEffect(() => {
   if (filter === null) {
    localStorage.setItem('filter', '');
   }
  }, [filter]);

  return (
    <FilterContext.Provider value={{ filter, setFilter }}>
      {children}
    </FilterContext.Provider>
  );
};

export default FilterProvider;
